import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from "@skylab-shared/core";
import { fillPlaceholders } from "@skylab-shared/utils";

export interface KsefReceiveUpoParams {
    ksefDocumentId: string;
}

export class KsefReceiveUpoCommand extends Command<KsefReceiveUpoParams, void>{}

export class KsefReceiveUpoCommandBase implements CommandHandler<KsefReceiveUpoCommand, KsefReceiveUpoParams, void>{
    private static Url = TaggedUrl.join('eInvoices/upo/:ksefDocumentId/receive', [Tags.Api]);
    public constructor(private readonly http: HttpService){
    }

    public async handleAsync(command: KsefReceiveUpoCommand): Promise<void> {
        const url = fillPlaceholders(KsefReceiveUpoCommandBase.Url, {ksefDocumentId: command.params?.ksefDocumentId});
        await this.http.post(url);
    }
}
